import { Component, OnInit, AfterViewInit, PLATFORM_ID, Inject } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../_services/langhfre.service';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { WINDOW } from '@ng-toolkit/universal';
import * as $ from 'jquery';
//declare function ire(string,{}): any;

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FAQComponent implements OnInit {

  constructor(private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService,
    @Inject(WINDOW) private window: Window,
    ) { }

    ngOnInit() {
      this.titleService.setTitle('AI搭載英文校正ツールTrinka（トリンカ） –｜よくあるご質問');
      this.metaTagService.updateTag({ name: 'description', content: "AIによる英文校正ツールTrinka（トリンカ）についてよくいただくご質問と回答をまとめたページです。" });
      this.metaTagService.updateTag({ property: 'og:title', content: 'AI搭載英文校正ツールTrinka（トリンカ） –｜よくあるご質問' });
      this.metaTagService.updateTag({ property: 'og:description', content: 'AIによる英文校正ツールTrinka（トリンカ）についてよくいただくご質問と回答をまとめたページです。' });
      this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/jp/faqs' });
      this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
      this.metaTagService.updateTag({ name: 'language', content: 'ja-jp' });
      this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/jp/faqs' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/faqs' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/faqs' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/faqs' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/faqs' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/faqs' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/faqs' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/faqs' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/faqs' });
      //ire('identify', {'customerId':'', customerEmail: '', customProfileId: this.generateGuid()});
    }
    gotoTop() {
      if (isPlatformBrowser(this.platformId)) {
        $.getScript('../../../assets/js/wisepop.js', function () { });
        $.getScript('../../../assets/js/faq_schema_final.js', function () { });
        this.window.scroll({
          top: 450,
          left: 0,
          behavior: 'smooth'
        });
      }
    }

}
